import PageTemplate from '../components/PageTemplate';
import { PRIVACY_CONTENT, CURRENT_PRIVACY_VERSION } from '../config/legal';
import { renderLegalMarkdown } from '../utils/legalMarkdown';
import { usePageTitle } from '../hooks/usePageTitle.js';

const Privacy = () => {
  usePageTitle('Política de Privacidade');
  const html = renderLegalMarkdown(PRIVACY_CONTENT);
  return (
    <PageTemplate showSearchInput={false} alwaysShowLogo>
      <article className="max-w-3xl mx-auto px-4 py-8 sm:px-6 sm:py-12">
        <p className="text-xs font-semibold uppercase tracking-widest text-gray-500 dark:text-gray-400">
          Versão {CURRENT_PRIVACY_VERSION}
        </p>
        <div className="legal-content" dangerouslySetInnerHTML={{ __html: html }} />
      </article>
    </PageTemplate>
  );
};

export default Privacy;
